import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/self-storage-facilities-near-me.jpg'),
    alt: 'self storage facilities near me page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'self storage facilities near me page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Find <span>Self Storage</span><span>Facilities Near Me</span>',
  description:
    'Looking for secure and affordable self-storage facilities near you? We offer top-notch storage solutions to meet your personal and business needs, right in your neighborhood.',
  image: {
    url: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/hero-image.jpg',
    alt: 'Find Self Storage Facilities Near Me'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Self Storage Facilities' }
}

export const ourProcessSectionContent = {
  title: 'How Our Self-Storage Facilities Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/how-our-self-storage-facilities-work.png',
    alt: 'How Our Self-Storage Facilities Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Access Locations',
      description:
        'Our storage facilities are conveniently located near you, making it simple to store and access your items whenever needed.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/easy-access-locations.png',
        alt: 'Easy Access Locations'
      }
    },
    {
      id: 2,
      title: 'Secure Units',
      description:
        'Each unit is equipped with advanced security features, including 24/7 surveillance, to ensure your belongings are safe.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/secure-units.png',
        alt: 'Secure Units'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Options',
      description: 'Choose from a variety of unit sizes and rental terms, tailored to fit your unique requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Self Storage Facilities',
  description:
    'Our self-storage facilities offer a perfect blend of convenience, security, and affordability. Whether you need short-term or long-term storage, we have solutions tailored to meet your needs. Enjoy peace of mind with our secure units and accessible locations, making storage simple and stress-free.',
  image: {
    src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/affordable-self-storage-facilities.jpg',
    alt: 'Affordable Self Storage Facilities'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Self-Storage Facilities Near You',

  cards: [
    {
      id: 1,
      title: 'Convenient Locations',
      description:
        'Our facilities are strategically located near residential and business areas, ensuring quick and easy access.',
      image: {
        src: '/images/v2/pages/common/convenient-locations.png',
        alt: 'Convenient Locations'
      }
    },
    {
      id: 2,
      title: 'Affordable Pricing',
      description: 'Enjoy competitive rates with flexible payment plans that fit your budget.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 3,
      title: 'Secure Storage',
      description:
        'All units are equipped with advanced security measures, including gated access and individual locks.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Secure Storage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Self-Storage Facilities?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description: 'Store seasonal items, furniture, and more while decluttering your home.'
        },
        {
          id: 2,
          title: 'Businesses',
          description: 'Keep excess inventory, equipment, and documents in a secure location.'
        },
        {
          id: 3,
          title: 'Students',
          description: 'Store belongings during school breaks with flexible rental terms.'
        },
        {
          id: 4,
          title: 'Travelers',
          description: "Securely store personal items while you're on the move'"
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/who-should-use-our-self-storage-facilities.jpg',
        alt: 'Who Should Use Our Self-Storage Facilities?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Storage Services',

  cards: [
    {
      id: 1,
      title: 'Personal Storage Units',
      description: 'Perfect for storing furniture, seasonal items, and personal belongings.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Personal Storage Units'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Student Storage Options',
      description: 'Flexible, affordable storage designed for students during school breaks.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'Student Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage Solutions',
      description: 'Secure storage for inventory, office supplies, and documents.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Vehicle Storage Solutions',
      description: 'Store your car, boat, or RV in a secure, monitored facility.',
      image: {
        src: '/images/v2/pages/common/vehicle-storage.png',
        alt: 'Vehicle Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Self-Storage Near You?',

  image: {
    url: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/why-choose-us-for-self-storage-near-you.jpg',
    alt: 'Why Choose Us for Self-Storage Near You?'
  },

  articles: [
    {
      id: 1,
      title: 'Wide Range of Unit Sizes',
      description: 'Find the perfect unit size for your storage needs, from small lockers to large spaces.'
    },
    {
      id: 2,
      title: 'Flexible Rental Terms',
      description: 'Enjoy short-term or long-term rental options to suit your needs.'
    },
    {
      id: 3,
      title: 'Climate-Controlled Units',
      description: 'Protect sensitive items like electronics and documents from temperature extremes.'
    },
    {
      id: 4,
      title: 'Exceptional Customer Support',
      description: 'Our team is always available to assist you with your storage questions and requirements.'
    },
    {
      id: 5,
      title: 'Advanced Security Features',
      description: 'Our facilities are equipped with 24/7 surveillance, gated access, and alarm systems.'
    },
    {
      id: 6,
      title: 'Local Convenience',
      description: 'With multiple locations nearby, accessing your stored items has never been easier.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Self Storage Facilities Near You Today',
  description:
    'Find self storage facilities near you. Secure, affordable options for storing your belongings conveniently and safely near your location.',
  image: {
    src: '/images/v2/pages/landing-pages/self-storage-facilities-near-me/find-self-storage-facilities-near-you-today.png',
    alt: 'Find Self Storage Facilities Near You Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description:
    'We work with leading shipping companies to provide additional logistics support for your storage needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures fast and reliable shipping services for your stored items, making the process seamless.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers international shipping services, ensuring safe transportation of your belongings to or from our storage facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure and efficient shipping solutions for your storage needs, ensuring timely delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
